import React from "react";

import { observer } from "mobx-react";
import { useTranslation } from "react-i18next";

import { useRootAppStore } from "@hooks";
import { BetBuilderPick } from "@data-types/bet-booster/BetBuilderPicks";
import { BetBuilderPickActionsTypeEnum } from "@data-types/analytics-tracker/QuickPlayInteractionTypeEnum";

import { analyticsTracker } from "@utils/analytics";
import BetBuilderPicksCard from "./BetBuilderPicksCard";
import QuickPlayEventResultAndTime from "@features/quick-play/shared/QuickPlayEventResultAndTime";

export const BetBuilderPicksSliderItem = observer(
	function BetBuilderPicksSliderItem(props: {
		BBPick: BetBuilderPick;
		index: number;
		isDragging: boolean;
		activatePopup: (id: string, index: number, show: boolean) => void;
	}) {
		const t = useTranslation().t;

		const rootStore = useRootAppStore();
		const handleClick = (e: React.MouseEvent) => {
			e.stopPropagation();
			e.preventDefault();
			if (props.isDragging) {
				return null;
			}

			analyticsTracker.trackQuickPlayInteraction(
				BetBuilderPickActionsTypeEnum.PickClick
			);

			props.activatePopup(props.BBPick.id, props.index, false);
		};

		const event =
			rootStore.quickPlayStore.betBoosterStore.eventsResultHubStore.getEvent(
				props.BBPick.eventId
			);

		return (
			<div
				onClick={handleClick}
				className="carousel__slide carousel--most__slide"
			>
				<div className="card card--qp card--qp--borderless card--qp--nowrap card--bbp card--bbp--nowrap">
					<div className="card__header card--bbp__header u-padd--reset">
						<QuickPlayEventResultAndTime
							event={event}
							startTime={props.BBPick.startTime}
						/>

						{props.BBPick.isLive && (
							<span className="card--qp__tag tag tag--tny tag--live--ghost tag--bolder">
								{t<string>("COMMON.LIVE")}
							</span>
						)}
					</div>

					<div className="card--qp__body card--bbp__body">
						<BetBuilderPicksCard
							BBPick={props.BBPick}
							maxOffers={2}
						/>
					</div>
				</div>
			</div>
		);
	}
);
